import React, { Component } from 'react';
import axios from 'axios'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { Button, Divider, Form, Segment } from 'semantic-ui-react'
import { SingleDatePicker } from 'react-dates';

class CommPay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commAmount:'',
        }
    }

    componentDidMount(){
        console.log("commx1 CommPay ++++ componentDidMount");

        if(this.props.project){
            console.log("commx11 project loaded:"+this.props.project.name);
           // console.log("commx112 project loaded:"+JSON.stringify(this.props.project,null,3));
            console.log("commx111 project proft:"+this.props.project.profit);

            let tempComm = 0;

            tempComm = this.props.project.profit * .1;
            console.log("commx12 tempComm is:"+tempComm);

            this.setState({
                commAmount: tempComm
            })
        }else{
            console.log("commx13 no proeject snet!")
        }
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')
        })
    }

    sendCommPayment = () => {
        console.log("++++++++:markDeliveryDate");
        console.log("this.props.projectId:" + this.props.projectId)
        console.log("this.props.user.email:" + this.props.user.email)
        console.log("dateNum:" + this.state.dateNum)

        if (this.props.project.idlargeprojects == '') {
            alert("No projectId ")
        } else if (this.props.user.email == '') {
            alert("No Entered By Provided")
        } else if (this.state.commAmount == '') {
            alert("No commAmount Selected")
        } else if (this.state.dateNum == '') {
            alert("No datePaid Selected")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'payCommissionOnProject', {
                apiKey: "APODFASF@dDFDD",
                projectId: this.props.project.idlargeprojects,
                enteredBy: this.props.user.email,
                commAmount: this.state.commAmount,
                datePaid: this.state.dateNum,
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding project");

                        alert(response.data.message);
                        //history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const enterCommButton = this.state.commAmount != ''
        ? <Button>PAY COMM</Button>
        : ''

        return (<div>
            <Divider horizontal>{'PAY COMM'}</Divider>

            <Form size='large' onSubmit={this.sendCommPayment}>
                <Segment stacked>
                    <h3>ENTER COMM</h3>
                    <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>

                    <label>Enter COMM AMOUNT</label>
                    <Form.Input
                        fluid
                        icon='money'
                        iconPosition='left'
                        placeholder='Comm Amount'
                        type='text'
                        name="commAmount"
                        value={this.state.commAmount}
                        onChange={this.handleTextInputChange}
                    />

                    {enterCommButton}
                </Segment>
            </Form>
        </div>);
    }
}

export default CommPay;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/CommPay.js